/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Empty_StateInputs */

const en_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found`)
};

const fr_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun element trouve`)
};

const de_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Artikel gefunden`)
};

const it_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun elemento trovato`)
};

const ru_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары не найдены`)
};

const es_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron artículos`)
};

const zh_cn2_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到任何物品`)
};

const ja_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムが見つかりません`)
};

const hi_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई आइटम नहीं मिला`)
};

const pt_pt2_explorer_thumbnail_empty_state = /** @type {(inputs: Explorer_Thumbnail_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum item encontrado`)
};

/**
* | output |
* | --- |
* | "No items found" |
*
* @param {Explorer_Thumbnail_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_empty_state = /** @type {((inputs?: Explorer_Thumbnail_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_empty_state(inputs)
	if (locale === "de") return de_explorer_thumbnail_empty_state(inputs)
	if (locale === "it") return it_explorer_thumbnail_empty_state(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_empty_state(inputs)
	if (locale === "es") return es_explorer_thumbnail_empty_state(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_empty_state(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_empty_state(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_empty_state(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_empty_state(inputs)
	return en_explorer_thumbnail_empty_state(inputs)
});